export default class FlashMessage {
    static init(): void {
        const messages = document.querySelectorAll('.flash-message');

        if (messages.length > 0) {
            messages.forEach((message) => {
                message.addEventListener('click', () => {
                    message.remove();
                });

                setTimeout(() => {
                    message.remove();
                }, 5000);
            });
        }
    }
}
